var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('van-picker',{attrs:{"title":"选择银行","show-toolbar":"","columns":_vm.columns},on:{"confirm":_vm.confirmBankBoxFun,"cancel":function($event){return _vm.showPopup(false)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }